import React, { useState } from 'react'
import { Controller } from 'react-hook-form'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DateTimePicker } from '@mui/x-date-pickers'
import { TextField } from '@mui/material'
const CommonDateTimePicker = ({
  control,
  name,
  onDateChange,
  type = 'DateTimePicker',
  format = 'DD-MM-YYYY hh:mm A',
  shouldDisableDate,
  shouldDisableTime,
  disablePast = true,
  slotActionBtn,
  minDateTime
}) => {
  const [open, setOpen] = useState(false)
  const slotActionBar = ['clear', 'cancel', 'accept']
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={[type]}>
        <Controller
          name={name}
          control={control}
          render={({ field: { value, onChange }, fieldState }) => (
            <>
              <DateTimePicker
                value={value ? value : null}
                format={format}
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                minDateTime={minDateTime}
                onChange={(newValue) => {
                  onChange(newValue)
                  onDateChange && onDateChange(newValue)
                }}
                timeSteps={{ hours: 1, minutes: 1 }}
                disablePast={disablePast}
                slotProps={{
                  actionBar: {
                    actions: slotActionBtn || slotActionBar
                  }
                }}
                shouldDisableDate={shouldDisableDate || false}
                shouldDisableTime={shouldDisableTime || false}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    InputProps={{
                      ...params.InputProps
                    }}
                  />
                )}
              />

              {fieldState?.error && <small style={{ color: 'red', marginTop: 0 }}>{fieldState?.error?.message}</small>}
            </>
          )}
        />
      </DemoContainer>
    </LocalizationProvider>
  )
}

export default CommonDateTimePicker
